@if (isEnabled()) {
  <!-- Access and authentication type -->
  <input type="hidden" class="bpmpi_auth" value="true" />
  <input type="hidden" class="bpmpi_auth_notifyonly" value="false" />
  <input type="hidden" class="bpmpi_auth_suppresschallenge" value="false" />
  <input type="hidden" class="bpmpi_accesstoken" [value]="accessToken()" />

  <!-- Order -->
  <input type="hidden" class="bpmpi_ordernumber" [value]="orderId()" />
  <input type="hidden" class="bpmpi_totalamount" [value]="totalAmount()" />
  <input type="hidden" class="bpmpi_currency" value="BRL" />
  <input type="hidden" class="bpmpi_installments" [value]="installments()" />
  <input type="hidden" class="bpmpi_paymentmethod" value="Credit" />
  <input type="hidden" class="bpmpi_order_recurrence" value="false" />
  <input type="hidden" class="bpmpi_order_productcode" value="PHY" />
  <input type="hidden" class="bpmpi_merchant_url" [value]="merchantUrl()" />

  <!-- Card data -->
  <input type="hidden" class="bpmpi_cardnumber" [value]="rawCardNumber()" />
  <input type="hidden" class="bpmpi_cardexpirationmonth" [value]="expMonth()" />
  <input type="hidden" class="bpmpi_cardexpirationyear" [value]="expYear()" />

  <!-- User -->
  <input type="hidden" class="bpmpi_useraccount_guest" value="true" />

  <!-- Device -->
  @if (deviceIpAddress()) {
    <input type="hidden" class="bpmpi_device_ipaddress" [value]="deviceIpAddress()" />
  }
  <input type="hidden" class="bpmpi_device_channel" value="Browser" />

  <!-- Establishment -->
  <input type="hidden" class="bpmpi_brand_establishment_code" [value]="establishmentCode()" />

  <!-- Cart items -->
  @for (product of products(); track product.Id; let i = $index) {
    <input type="hidden" [class]="'bpmpi_cart_' + (i + 1) + '_description'" [value]="product.Name" />
    <input type="hidden" [class]="'bpmpi_cart_' + (i + 1) + '_name'" [value]="product.Name" />
    <input type="hidden" [class]="'bpmpi_cart_' + (i + 1) + '_sku'" [value]="product.Id" />
    <input type="hidden" [class]="'bpmpi_cart_' + (i + 1) + '_unitprice'" [value]="product.Price" />
    <input type="hidden" [class]="'bpmpi_cart_' + (i + 1) + '_quantity'" [value]="product.Quantity" />
  }

  <!-- Extra fields from Context["3DS"] — merged on top of defaults -->
  @for (field of contextFields(); track field.key) {
    <input type="hidden" [class]="field.key" [value]="field.value" />
  }
}
